export const makeField = (value, fieldPath, fieldStatus, isRequired) => {
  return { value, fieldPath, fieldStatus, isRequired }
}

export const makeFieldWithInvalid = (value, fieldPath, fieldStatus, isRequired, invalid) => {
  return { value, fieldPath, fieldStatus, isRequired, invalid }
}
